var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("text-area-row", {
        attrs: {
          title: "SummaryReport.Results.Meter.Description",
          id: "meterdescription_" + _vm.targetIndex + "_" + _vm.meterIndex,
          required: true,
          maxLength: 250,
          rows: 3,
          noResize: true
        },
        model: {
          value: _vm.meter.description,
          callback: function($$v) {
            _vm.$set(_vm.meter, "description", $$v)
          },
          expression: "meter.description"
        }
      }),
      _vm._v(" "),
      _c("radio-button-option-row", {
        attrs: {
          title: "SummaryReport.Results.Meter.MeasurementMethod",
          componentIndex: _vm.meterIndex,
          required: true,
          options: _vm.optionsArray("UpdatedMeasurementMethodOptions", true),
          secondaryIndex: _vm.targetIndex
        },
        model: {
          value: _vm.meter.updatedMeasurementMethod,
          callback: function($$v) {
            _vm.$set(_vm.meter, "updatedMeasurementMethod", $$v)
          },
          expression: "meter.updatedMeasurementMethod"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-row", {
        attrs: {
          title: "SummaryReport.Results.Meter.AskedCount",
          id: "askedcount_" + _vm.targetIndex + "_" + _vm.meterIndex,
          rules: {
            min_value: _vm.meter.answerCount ? _vm.meter.answerCount : 0,
            max_value: 1000000000
          },
          required: true
        },
        model: {
          value: _vm.meter.askedCount,
          callback: function($$v) {
            _vm.$set(_vm.meter, "askedCount", $$v)
          },
          expression: "meter.askedCount"
        }
      }),
      _vm._v(" "),
      _c("numeric-input-row", {
        attrs: {
          title: "SummaryReport.Results.Meter.AnswerCount",
          id: "answercount_" + _vm.targetIndex + "_" + _vm.meterIndex,
          rules: {
            min_value: 0,
            max_value: _vm.meter.askedCount ? _vm.meter.askedCount : 1000000000
          },
          required: true
        },
        model: {
          value: _vm.meter.answerCount,
          callback: function($$v) {
            _vm.$set(_vm.meter, "answerCount", $$v)
          },
          expression: "meter.answerCount"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }